import { inject, Injectable } from '@angular/core';
import { EmployeeCreateModel, EmployeeModel, EmployeeRoleModel, EmployeeRoleRefModel } from '@libs/account/models';
import { Observable } from 'rxjs';
import { EmployeeRepositoryService } from './repository';

@Injectable({
  providedIn: 'root',
})
export class EmployeeService {
  private readonly repository: EmployeeRepositoryService = inject(EmployeeRepositoryService);

  public getDelegatableRoles(): Observable<EmployeeRoleModel[]> {
    return this.repository.getDelegatableRoles();
  }

  public getEmployees(): Observable<EmployeeModel[] | undefined> {
    return this.repository.getEmployees();
  }

  public getEmployee(id: string): Observable<EmployeeModel> {
    return this.repository.getEmployee(id);
  }

  public createEmployee(payload: EmployeeCreateModel): Observable<EmployeeModel> {
    return this.repository.createEmployee(payload);
  }

  public deleteEmployee(id: string): Observable<void> {
    return this.repository.deleteEmployee(id);
  }

  public renewInvitationEmployee(id: string): Observable<void> {
    return this.repository.renewInvitationEmployee(id);
  }

  public replaceEmployeeRoles(id: string, roles: EmployeeRoleRefModel[]): Observable<void> {
    return this.repository.replaceEmployeeRoles(id, roles);
  }
}
